import React, { useEffect, useState } from "react";
import { heroData } from "../../data/home";
import { mediaUrl } from "../../services/assetUrl";
import CtaLink from "./CtaLink";
import "./homeRedesign.css";

const Hero = ({ data }) => {
  const { eyebrow, video, slides = [], primaryCta, secondaryCta } = data || heroData;
  const [idx, setIdx] = useState(0);

  // Rotate the overlaid headline/description while the video plays underneath.
  useEffect(() => {
    if (slides.length < 2) return undefined;
    const timer = setInterval(() => {
      setIdx((i) => (i + 1) % slides.length);
    }, 5500);
    return () => clearInterval(timer);
  }, [slides.length]);

  const active = slides[idx] || { title: "", description: "" };
  const hasVideo = video && video.src;

  return (
    <section className="hero-ed" aria-label="NCET highlights">
      <div className="hero-ed__slide">
        {hasVideo ? (
          <video
            className="hero-ed__video"
            autoPlay
            muted
            loop
            playsInline
            preload="auto"
            aria-hidden="true"
          >
            <source src={mediaUrl(video.src)} type="video/mp4" />
          </video>
        ) : (
          active.image && (
            <div
              className="hero-ed__bg"
              style={{ backgroundImage: `url(${mediaUrl(active.image)})` }}
              role="img"
              aria-label={active.title}
            />
          )
        )}

        <div className="hero-ed__scrim" />

        <div className="container hero-ed__inner">
          <div className="hero-ed__content">
            <span className="hero-ed__eyebrow">{eyebrow}</span>
            <div className="hero-ed__rotator" key={idx}>
              <h1 className="hero-ed__title">{active.title}</h1>
              <p className="hero-ed__desc">{active.description}</p>
            </div>
            <div className="hero-ed__cta">
              <CtaLink to={primaryCta.link} className="btn-ed btn-ed--primary">
                {primaryCta.text}
              </CtaLink>
              <CtaLink to={secondaryCta.link} className="btn-ed btn-ed--ghost btn-ed--ghost-light">
                {secondaryCta.text}
              </CtaLink>
            </div>

            {slides.length > 1 && (
              <div className="hero-ed__dotsrow" role="tablist" aria-label="Highlights">
                {slides.map((slide, i) => (
                  <button
                    key={i}
                    type="button"
                    aria-label={slide.title}
                    aria-selected={i === idx}
                    className={`hero-ed__dot${i === idx ? " is-active" : ""}`}
                    onClick={() => setIdx(i)}
                  />
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
